import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import { ValueLabelProps, SliderProps } from '@material-ui/core/Slider';

import Grid from '../Grid';
import units from '../theme/units';

const useStyles = makeStyles(theme => ({
  offset: {
    zIndex: 1,
    ...theme.typography.body2,
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.shortest,
    }),
    top: -38,
    transformOrigin: 'bottom center',
    transform: 'scale(0)',
    position: 'absolute',
  },
  open: {
    transform: 'scale(1)',
  },
  label: {
    borderRadius: units.rem(0.2),
    padding: units.yx(0.25, 0.5),
    color: theme.palette.white.main,
    backgroundColor: theme.palette.grey['700'],
  },
}));

type Props = ValueLabelProps &
  Pick<SliderProps, 'valueLabelDisplay' | 'valueLabelFormat'> & {
    index: number;
  };

const ValueLabel: React.FC<Props> = props => {
  const { children, className, open, value, valueLabelDisplay } = props;

  const classes = useStyles();

  if (valueLabelDisplay === 'off') {
    return children;
  }

  return React.cloneElement(
    children,
    {},
    <span
      className={cx(
        classes.offset,
        { [classes.open]: open || valueLabelDisplay === 'on' },
        className,
      )}
      data-test-locator="Slider Value Label"
    >
      <Grid
        container
        alignItems="center"
        justify="center"
        wrap="nowrap"
        className={classes.label}
      >
        {value}
      </Grid>
    </span>,
  );
};

export default ValueLabel;
